import { call, put, takeLatest } from 'redux-saga/effects';
import { eThanhPhanDiemActionTypeIds } from '../../action-types/so-diem/IThanhPhanDiemAction';
import { thanhPhanDiemApi } from './../../../api/thanhPhanDiemApi';
import { IBaseResponeModel } from './../../../models/response/base-response';
import { actions } from './../../actions/actionsWrapper';
export function* thanhPhanDiemSaga(): any {
    yield takeLatest(eThanhPhanDiemActionTypeIds.LOAD_START, loadWorker);
}
function* loadWorker(): any {
    const res: IBaseResponeModel = yield call([thanhPhanDiemApi, thanhPhanDiemApi.SelectAll]);
    if (res.is_success) {
        yield put(actions.soDiem.thanhPhanDiem.loadSuccess(res.data))
    } else {
        yield put(actions.soDiem.thanhPhanDiem.loadError(res.message || "Không tải được thành phần điểm"))
    }
}